import { render, staticRenderFns } from "./FingerprintAuthorization.vue?vue&type=template&id=381e0fce&scoped=true&"
import script from "./FingerprintAuthorization.vue?vue&type=script&lang=js&"
export * from "./FingerprintAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./FingerprintAuthorization.vue?vue&type=style&index=0&id=381e0fce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e0fce",
  null
  
)

export default component.exports